import GUI from 'lil-gui'

export default function createDebug()
{
  const gui = new GUI({ width: 325 })
  return { gui }
}
